// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__112Hx","boxTitle":"Qualiphy_boxTitle__oVmWB","box":"Qualiphy_box__30Qu8","toggleWrap":"Qualiphy_toggleWrap__zWDmd"};